import { createAsyncThunk } from '@reduxjs/toolkit';

import { modelosCartaService } from './services';
import type {
  CreateModeloCartaDto,
  ModeloCarta,
  UpdateModeloCartaDto,
} from '../types/modeloCartaTypes';

const toErrorMessage = (error: unknown, fallback: string): string =>
  error instanceof Error ? error.message : fallback;

export const listarModelosCarta = createAsyncThunk<ModeloCarta[], void, { rejectValue: string }>(
  'modelosCarta/listar',
  async (_, { rejectWithValue }) => {
    try {
      return await modelosCartaService.listar();
    } catch (error) {
      return rejectWithValue(toErrorMessage(error, 'Não foi possível carregar os modelos.'));
    }
  },
);

export const buscarModeloCarta = createAsyncThunk<ModeloCarta, string, { rejectValue: string }>(
  'modelosCarta/buscar',
  async (id, { rejectWithValue }) => {
    try {
      return await modelosCartaService.buscar(id);
    } catch (error) {
      return rejectWithValue(toErrorMessage(error, 'Não foi possível carregar o modelo.'));
    }
  },
);

export const criarModeloCarta = createAsyncThunk<
  ModeloCarta,
  CreateModeloCartaDto,
  { rejectValue: string }
>('modelosCarta/criar', async (data, { rejectWithValue }) => {
  try {
    return await modelosCartaService.criar(data);
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível criar o modelo.'));
  }
});

export const atualizarModeloCarta = createAsyncThunk<
  ModeloCarta,
  { id: string; data: UpdateModeloCartaDto },
  { rejectValue: string }
>('modelosCarta/atualizar', async ({ id, data }, { rejectWithValue }) => {
  try {
    return await modelosCartaService.atualizar(id, data);
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível salvar o modelo.'));
  }
});

export const alternarStatusModeloCarta = createAsyncThunk<
  ModeloCarta,
  string,
  { rejectValue: string }
>('modelosCarta/alternarStatus', async (id, { rejectWithValue }) => {
  try {
    return await modelosCartaService.alternarStatus(id);
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível atualizar o status.'));
  }
});
